import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#F15060',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.8 59.5"
    >
      <path
        className={classes.path}
        d="M61.3,58.6v-3.1c0-0.5,0.1-1,0.3-1.5L81,0.6C81.1,0.2,81.5,0,81.9,0h8c0.7,0,1.1,0.7,0.9,1.3l-21,57.6
        c-0.1,0.4-0.5,0.6-0.9,0.6h-6.7C61.7,59.5,61.3,59.1,61.3,58.6z M94.2,59.5h6.7c0.4,0,0.8-0.2,0.9-0.6l21-57.6
        c0.2-0.6-0.2-1.3-0.9-1.3h-8c-0.4,0-0.8,0.2-0.9,0.6L93.5,54c-0.2,0.5-0.3,1-0.3,1.5v3.1C93.3,59.1,93.7,59.5,94.2,59.5z M38,59.5
        h6.3c0.5,0,0.9-0.4,0.9-0.9v-3.1c0-0.5-0.1-1-0.3-1.5L25.7,0.6C25.5,0.2,25.2,0,24.8,0h-4.2c-0.4,0-0.8,0.2-0.9,0.6L0.3,54
        c-0.2,0.5-0.3,1-0.3,1.5v3.1c0,0.5,0.4,0.9,0.9,0.9h6.3c0.4,0,0.8-0.2,0.9-0.6l14.5-39.8l14.5,39.8C37.3,59.3,37.6,59.5,38,59.5z"
      />
    </svg>
  );
};
